import { render } from "./Download.vue?vue&type=template&id=1fd1adde&scoped=true"
import script from "./Download.vue?vue&type=script&lang=js"
export * from "./Download.vue?vue&type=script&lang=js"

import "./Download.vue?vue&type=style&index=0&id=1fd1adde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fd1adde"]])

export default __exports__